import PropTypes from 'prop-types'
import React from 'react'
import initialState from '../src/modules/redux/initialState'
import { deepCopy } from '../src/utils'
import { CookiesHelper } from '../src/core/cookiesHelper/CookiesHelper'
import { withAuth } from '../src/modules/users/Auth/components'
import { ProfileRouter } from '../src/modules/users/Profile'
import { connect } from 'react-redux'
import { Page, Page404 } from '../src/ui'
import { Notifications } from '../src/modules/users/Profile/components'
import { profileMenu } from '../src/modules/users/Profile/constants'
import { fetchCountries } from '../src/modules/geoObjects/countries/actions'
import { fetchCitiesByCountry } from '../src/modules/geoObjects/cities/actions'
import { adsTypes, globalOptions } from '../src/core/constants'
import { fetchAds } from '../src/modules/ads/list/actions'
import { adsStatues } from '../src/modules/ads/shared/constants'
import { getUserInfo } from '../src/modules/users/Profile/selectors'
import {
  fetchPackages,
  setDiscounts,
  setPackages,
  setSelectedPackage
} from '../src/modules/users/packages/actions'
import {
  fetchFavouriteAds,
  fetchSavedFilters,
  fetchFavouriteProfiles,
  setProfileAdsQuery,
  setProfilePage
} from '../src/modules/users/Profile/actions'
import config from '../src/config/config.json'

class ProfilePage extends React.Component {
  static async getInitialProps ({store, req, query}) {
    let sectionName, userId, token

    let needToBeAuthorized = true

    let isPageExists = false
    if (!query.page) {
      isPageExists = true
    } else {
      for (let menuItem of profileMenu) {
        if (menuItem.code === query.page) {
          isPageExists = true
        }
      }

      if (query.page === 'notifikacije') isPageExists = true
    }

    if (req) {
      userId = req.cookies.userId || null
      token = req.cookies.token || null
    } else {
      const cookies = new CookiesHelper()
      userId = cookies.get('userId') || null
      token = cookies.get('token') || null
    }

    let page = 1

    if (req) {
      if (req.query.pageNumber) page = Number(req.query.pageNumber)
    } else {
      if (query.pageNumber) page = Number(query.pageNumber)
    }

    const profilePaginationParams = {
      ...store.getState().user.profile.pagination.params
    }

    if (isPageExists) {
      await store.dispatch(fetchCountries(query?.locale?.toUpperCase() || 'ME'))

      switch (query.page) {
        case profileMenu.my.code: break
        case profileMenu.ads.code:
          if (userId && token) {
            let status, q, group, category, brand, product, compatibility, fullText
            let type = adsTypes.all
            const isMobileDevice = store.getState().common.isMobileDevice

            const limit = !isMobileDevice ? globalOptions.adsCountPerPage : globalOptions.adsCountPerPageMobile

            const profileAdsQuery = {}
            if (req) {
              status = req.query.status || 'Published'
              q = req.query.q || null
              brand = req.query.brand || null
              product = req.query.product || null
              compatibility = req.query.compatibility || null
              fullText = req.query.fullText || null
            } else {
              status = query.status || 'Published'
              q = query.q || null
              group = query.group || null
              category = query.category || null
              brand = query.brand || null
              product = query.product || null
              compatibility = query.compatibility || null
              fullText = query.fullText || null
            }
            if (status) {
              profileAdsQuery.status = status
            }
            if (q) {
              profileAdsQuery.q = q
            }
            if (group) {
              profileAdsQuery.group = group
            }
            if (category) {
              profileAdsQuery.category = category
            }
            if (brand) {
              profileAdsQuery.brand = brand
            }
            if (product) {
              profileAdsQuery.product = product
            }
            if (compatibility) {
              profileAdsQuery.compatibility = compatibility
            }
            if (fullText) {
              profileAdsQuery.fullText = fullText
            }
            store.dispatch(setProfileAdsQuery(profileAdsQuery))
            const options = {userId, token, adUser: userId, page, type, limit, showProfile: true, sortBy: 'dateDesc'}
            if (status) {
              switch (status) {
                case 'all':
                  break
                case 'Paid':
                  type = adsTypes.paid
                  options.type = adsTypes.paid
                  options.status = adsStatues.PUBLISHED.code
                  break
                default:
                  options.status = status
              }
            } else {
              options.status = adsStatues.PUBLISHED.code
            }
            if (brand) {
              options.brand = brand
            }
            if (product) {
              options.product = product
            }
            if (compatibility) {
              options.compatibility = compatibility
            }
            if (fullText) {
              options.fullText = fullText
            }

            options.locale = query?.locale?.toUpperCase() || 'ME'

            const paginationParams = {currentPage: page, countPerPage: limit, adsType: type}
            if (options.status === 'Inactive') {
              await store.dispatch(fetchAds({ ...options, status: 'Expired' }, paginationParams))
              await store.dispatch(fetchAds({ ...options, status: 'Paused' },
                paginationParams,
                store.getState().ads.list.elements)
              )
            } else {
              await store.dispatch(fetchAds(options, paginationParams))
            }
          }
          break
        case profileMenu.package.code:
          const state = store.getState()
          const user = getUserInfo(state)
          const selectedPackage = user && Array.isArray(user.packages) && user.packages.length && user.packages[0].id
          if (user && user.type && user.type.id) {
            await store.dispatch(fetchPackages(user.type.id))
            store.dispatch(setSelectedPackage(selectedPackage))
          } else {
            store.dispatch(setPackages([]))
            store.dispatch(setDiscounts([]))
            store.dispatch(setSelectedPackage(null))
          }
          break
        case profileMenu.savedAds.code:
          const savedAdsStatus = 'Published'
          const isFavouriteAdsFetchedInitially = store.getState().user.profile.favouriteAds.fetchedInitially
          if (userId && token) {
            console.log('isFavouriteAdsFetchedInitially', isFavouriteAdsFetchedInitially)
            !isFavouriteAdsFetchedInitially && await store.dispatch(fetchFavouriteAds(userId, token, savedAdsStatus, 1, 100))
          }
          break
        case profileMenu.savedFilters.code:
          if (userId && token) {
            await store.dispatch(fetchSavedFilters(userId, token, page, profilePaginationParams))
          }
          break
        case profileMenu.savedProfiles.code:
          if (userId && token) {
            await store.dispatch(fetchFavouriteProfiles(userId, token, profilePaginationParams.type || 0, page, profilePaginationParams))
          }
          break
        default: break
      }

      for (let menuItem of profileMenu) {
        if (menuItem.code === query.page) {
          sectionName = menuItem.title
        }
      }
      if (!sectionName) {
        sectionName = profileMenu.my.title
      }
    } else {
      sectionName = config.pages.notFoundTitle
    }

    if (isPageExists) {
      if (query.page) {
        store.dispatch(setProfilePage(query.page))
      } else {
        store.dispatch(setProfilePage(profileMenu.my.code))
      }
    }

    return {
      title: `${sectionName} | ${config.siteName}`,
      isPageExists,
      needToBeAuthorized,
      state: ProfilePage.getPageState(store, isPageExists, query.page)
    }
  }

  static getPageState (store, isPageExists = false, page) {
    const state = deepCopy(initialState)
    if (store) {
      const currentState = store.getState()

      state.user.auth.isAuthorized = currentState.user.auth.isAuthorized
      state.user.profile.error = currentState.user.profile.error
      state.user.profile.info = currentState.user.profile.info
      state.user.profile.newBanner = currentState.user.profile.newBanner
      state.user.profile.newLogo = currentState.user.profile.newLogo
      state.user.profile.currentPage = currentState.user.profile.currentPage
      state.user.profile.notifications = currentState.user.profile.notifications
      state.user.profile.favouriteAds = currentState.user.profile.favouriteAds
      state.user.profile.savedFilters = currentState.user.profile.savedFilters
      state.user.profile.pagination = currentState.user.profile.pagination
      state.user.profile.addons = currentState.user.profile.addons
      state.user.profile.favouriteProfiles = currentState.user.profile.favouriteProfiles
      state.user.profile.priceTypes = currentState.user.profile.priceTypes

      state.common.transitions = currentState.common.transitions
      state.common.router = currentState.common.router
      state.common.is404 = !isPageExists
      state.common.isMobileDevice = currentState.common.isMobileDevice
      state.common.userTypes = currentState.common.userTypes
      state.common.pageMetaTags = currentState.common.pageMetaTags
      state.common.pageMetaTagsSingle = currentState.common.pageMetaTagsSingle

      state.groups.elements = currentState.groups.elements

      state.categories.elements = currentState.categories.elements
      state.categories.bySeo = currentState.categories.bySeo

      state.ads.detail.reportTypes = currentState.ads.detail.reportTypes
      state.ads.detail.registrationFormulas = currentState.ads.detail.registrationFormulas
      // state.ads.listings = currentState.ads.listings

      state.form = currentState.form

      state.geoObjects.countries = currentState.geoObjects.countries
      state.geoObjects.regions = currentState.geoObjects.regions
      state.geoObjects.cities = currentState.geoObjects.cities

      state.notifications = currentState.notifications

      switch (page) {
        case profileMenu.my.code:
          break
        case profileMenu.ads.code:
          state.user.profile.ads = currentState.user.profile.ads
          state.ads.list = currentState.ads.list
          state.ads.pagination = currentState.ads.pagination
          break
        case profileMenu.package.code:
          state.user.packages = currentState.user.packages
          break
        default: break
      }
    }
    return state
  }

  render () {
    const {isPageExists, needToBeAuthorized} = this.props
    const RouterComponent = needToBeAuthorized ? withAuth(ProfileRouter) : ProfileRouter
    return isPageExists
      ? <Page>
        <Notifications />
        <RouterComponent />
      </Page>
      : <Page404 />
  }
}

ProfilePage.propTypes = {
  isPageExists: PropTypes.bool.isRequired,
  needToBeAuthorized: PropTypes.bool.isRequired
}

ProfilePage.defaultProps = {
  isPageExists: false
}

export default ProfilePage
